import type { ReactNode } from 'react';
import Modal from './Modal';

export interface DetailRow {
  label: string;
  value: ReactNode;
}

/**
 * Small read-only detail modal used by entity-list cards that do not already
 * have a bespoke detail view. Renders label/value rows in a clean, mobile-safe
 * list (values wrap instead of overflowing).
 */
export default function EntityDetailModal({
  open,
  onClose,
  title,
  rows,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  rows: DetailRow[];
  children?: ReactNode;
}) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="lg">
      <dl className="space-y-3">
        {rows.map((r, i) => (
          <div key={`${r.label}-${i}`} className="min-w-0">
            <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              {r.label}
            </dt>
            <dd className="mt-0.5 min-w-0 break-words text-sm text-slate-800 dark:text-slate-200">
              {r.value ?? '—'}
            </dd>
          </div>
        ))}
      </dl>
      {children}
    </Modal>
  );
}
